import pagination from "./pagination";
import visiblePanel from "./visiblePanel";
import webTab from "./webTab";
import server from "./server";
import applicationTab from "./applicationTab";
import databaseTab from "./databaseTab";
import smtpServerTab from "./smtpServerTab";
import logsTab from "./logsTab";
import performanceTab from "./performanceTab";

export {
    pagination,
    visiblePanel,
    webTab,
    server,
    applicationTab,
    databaseTab,
    smtpServerTab,
    logsTab,
    performanceTab
};